module.exports = __webpack_public_path__ + "static/media/img_location_nb.fa7efea4.jpg";